/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiV0ConstructionsiteDeleteConSiteIdDelete$Params {
  conSiteId: string;
}

export function apiV0ConstructionsiteDeleteConSiteIdDelete(http: HttpClient, rootUrl: string, params: ApiV0ConstructionsiteDeleteConSiteIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiV0ConstructionsiteDeleteConSiteIdDelete.PATH, 'delete');
  if (params) {
    rb.path('conSiteId', params.conSiteId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiV0ConstructionsiteDeleteConSiteIdDelete.PATH = '/api/v0/constructionsite/delete/{conSiteId}';
